import { Palette } from '@/themes/themeOverrides/Palette';

export const settingsSectionStyles = ({ theme }) => ({
    position: 'relative',
    paddingTop: '32px',
    marginTop: '32px',
    marginBottom: '32px',
    [theme.breakpoints.down('md')]: {
        paddingTop: '24px',
        paddingBottom: '40px',
        width: '100%',
    },
    '&:before, &:after': {
        content: '""',
        display: 'block',
        width: 'calc(100% + 112px)',
        height: '2px',
        background: Palette.gray.gray100,
        position: 'absolute',
        left: '-56px',
    },
    '&:before': {
        top: 0,
    },
    '&:after': {
        bottom: 0,
    },
    '& .MuiTypography-h5': {
        fontSize: '22px',
        lineHeight: '28px',
        marginBottom: '24px',
    },
    '& .MuiFormHelperText-root': {
        display: 'none',
        '&.Mui-error': {
            display: 'block',
        },
    },
    '& .contractor-edit-grid': {
        display: 'grid',
        gridTemplateColumns: '2fr 1fr',
        gap: '32px',
        width: '100%',
        [theme.breakpoints.down('md')]: { gridTemplateColumns: '1fr', gap: '24px' },
    },
    '& .settings-split': {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '32px',
        width: '100%',
        margin: '24px 0 56px',
        [theme.breakpoints.down('md')]: { gridTemplateColumns: '1fr', gap: '24px', margin: '24px 0' },
    },
    '& .settings-split.settings-split--compact': {
        margin: '24px 0 28px',
    },
    '& .settings-values': {
        display: 'flex',
        marginBottom: '2em',
        gap: '32px',
        [theme.breakpoints.down('md')]: { flexDirection: 'column', gap: '16px' },
        '& > *': {
            flex: 1,
        },
    },
    '& .settings-discount-row': {
        display: 'flex',
        marginBottom: '2em',
        [theme.breakpoints.down('md')]: { flexDirection: 'column', gap: '16px' },
        '& > *': {
            flex: 1,
            marginRight: '1em',
        },
    },
    '& .MuiFormLabel-root.RaCheckboxGroupInput-label': {
        fontSize: '14px',
        lineHeight: '12px',
        fontWeight: 700,
        letterSpacing: '0.4px',
        textTransform: 'uppercase',
        marginBottom: '6px',
        color: Palette.black,
        paddingLeft: '0',
        '&.Mui-error': {
            color: Palette.red.red400,
        },
    },
    '& .MuiTypography-root.MuiTypography-h6.MuiTypography-gutterBottom': {
        fontSize: '10px',
        lineHeight: '12px',
        fontWeight: 700,
        letterSpacing: '0.4px',
        textTransform: 'uppercase',
    },
});

export const settingsCheckboxGroupStyles = ({ theme }) => ({
    '& .MuiFormGroup-root': {
        '& .MuiFormControlLabel-root': {
            margin: 0,
            padding: '10px 12px',
            marginBottom: '0px',
            borderRadius: '8px',
            '& .MuiCheckbox-root': {
                padding: '0',
                margin: '0 8px 0 0',
                height: 'auto',
            },
            '& .MuiTypography-root': {
                padding: '0px',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                fontSize: '14px',
            },
            '&:hover': {
                background: Palette.yellow.yellow50,
                [theme.breakpoints.down('md')]: {
                    background: 'transparent',
                },
            },
        },
    },
    '& label[for="depositWithdrawalMethods_cash"]': {
        pointerEvents: 'none',
        '& svg': {
            fill: Palette.white,
            '& path': {
                stroke: Palette.gray.gray500,
            },
        },
    },
});
